/* Playably — Rebates intro page interactions.
   1) reveal-on-scroll (progressive enhancement; content is visible by default)
   2) hero rebate-widget live demo: scoreboard counts down → OVERTIME → 100% REFUNDED win → loop
   Both respect prefers-reduced-motion. */
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal-on-scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.reb-art [data-reveal]');
    if (!els.length) return;
    if (REDUCE) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    // Reveal on element TOP position (not % of element), so tall sections and
    // elements scrolled past on fast mobile scroll never get stuck hidden.
    function check() {
      var vh = window.innerHeight || 800;
      els.forEach(function (e) {
        if (e.classList.contains('in')) return;
        if (e.getBoundingClientRect().top < vh * 0.9) e.classList.add('in');
      });
    }
    check();
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { ticking = false; check(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // safety net: after load, reveal anything already in/above the viewport
    setTimeout(check, 350);
  }

  /* ---------- hero widget live demo ---------- */
  function spawnConfetti(win) {
    win.querySelectorAll('.reb-confetti').forEach(function (c) { c.remove(); });
    var colors = ['#1a1a1a', '#8660ff', '#ffffff', '#5e3fd9'];
    for (var i = 0; i < 16; i++) {
      var s = document.createElement('span');
      s.className = 'reb-confetti';
      s.style.left = (4 + Math.random() * 92) + '%';
      s.style.background = colors[i % colors.length];
      s.style.animationDelay = (Math.random() * 0.45) + 's';
      win.appendChild(s);
    }
  }

  function runDemo(mock) {
    var clock = mock.querySelector('.sb-clock');
    var board = mock.querySelector('.reb-scoreboard');
    var win = mock.querySelector('.reb-win');
    if (!clock || !board || !win) return;
    var timers = [];
    function clearTimers() { timers.forEach(clearTimeout); timers.splice(0); }

    function cycle() {
      clearTimers();
      mock.setAttribute('data-phase', 'entry');
      board.classList.remove('ot');
      var t = 12;
      clock.textContent = 'Q4 0:12';
      var tick = setInterval(function () {
        t--;
        if (t <= 0) {
          clearInterval(tick);
          clock.textContent = 'OVERTIME';
          board.classList.add('ot');
          timers.push(setTimeout(function () {
            mock.setAttribute('data-phase', 'win');
            spawnConfetti(win);
          }, 1000));
          timers.push(setTimeout(cycle, 5400)); // hold the win, then loop
        } else {
          clock.textContent = 'Q4 0:' + (t < 10 ? '0' : '') + t;
        }
      }, 220);
      timers.push({ /* keep interval clearable */ });
      // store interval id so a re-init can stop it
      mock._rebTick = tick;
    }
    if (mock._rebTick) clearInterval(mock._rebTick);
    cycle();
  }

  function initDemo(root) {
    var mocks = (root || document).querySelectorAll('.reb-art [data-reb-demo]');
    mocks.forEach(function (mock) {
      if (REDUCE) { mock.setAttribute('data-phase', 'entry'); return; }
      // start the loop only once the widget is on screen
      if (!('IntersectionObserver' in window)) { runDemo(mock); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { runDemo(mock); io.unobserve(mock); }
        });
      }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });
      io.observe(mock);
    });
  }

  function init(root) { initReveal(root); initDemo(root); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  // Shopify Theme Editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
